<template>
  <!-- <div class="flowArea"> -->
  <div style="width: 100%; height: 100%">
    <VueFlow
      class="vue-flow"
      :nodes="this.nodes"
      :edges="this.edges"
      :default-viewport="{ zoom: 0.2 }"
      :default-zoom="0.2"
      :min-zoom="0.7"
      :max-zoom="4"
      :pan-on-scroll="mouseMode == 'default'"
      :pan-on-drag="mouseMode == 'default'"
      zoom-activation-key-code="shift"
      @move="handleMove"
      ref="vueFlow"
    >
      <Background
        pattern-color="#aaa"
        :gap="16"
        variant="dots"
        mode="dynamic"
      />

      <!-- <CustomBackground /> -->

      <template #node-custom_input="specialNodeProps">
        <InputNode v-bind="specialNodeProps" />
      </template>
      <template #node-extract="specialNodeProps">
        <ExtractNode v-bind="specialNodeProps" />
      </template>
      <template #node-write="specialNodeProps">
        <WriteNode v-bind="specialNodeProps" />
      </template>
      <template #node-custom_output="specialNodeProps">
        <OutputNode v-bind="specialNodeProps" />
      </template>
      <template #node-base_node="specialNodeProps">
        <BaseNode v-bind="specialNodeProps" @updateNodeTool="updateNodeTool" />
      </template>
      <template #node-loading_node="specialNodeProps">
        <LoadingNode v-bind="specialNodeProps" />
      </template>
      <template #node-tool_node="specialNodeProps">
        <ToolNode v-bind="specialNodeProps" />
      </template>
      <template #node-parent_node="specialNodeProps">
        <ParentNode v-bind="specialNodeProps" />
      </template>

      <!-- <div class="topBar">hio</div> -->
    </VueFlow>

    <!-- <div class="topnavbtn" @click="copyToClipboard()">
      <div class="topnavtnHover">
        <ArrowDownToLine size="18" />
      </div>
    </div> -->
    <!-- <div id="menu" class="flexLeftRow">
      <div class="menu_btn" @click="copyToClipboard()">
        <Play strokeWidth="1.5" />
      </div>
      <div
        class="menu_btn"
        @click="toggleMouseMode('default')"
        :class="{ 'selectedMouseMode': this.mouseMode == 'default' }"
        style="margin-right: 5px"
      >
        <MousePointer2 strokeWidth="1.5" />
      </div>
      <div
        class="menu_btn"
        @click="toggleMouseMode('hand')"
        :class="{ 'selectedMouseMode': this.mouseMode == 'hand' }"
      >
        <Hand strokeWidth="1.5" />
      </div>
    </div> -->
  </div>
  <!-- </div> -->
</template>

<script>
// import { ref } from "vue";
import { VueFlow, useVueFlow } from "@vue-flow/core"; //MarkerType
import { Background } from "@vue-flow/background";
import InputNode from "@/components/flowNodes/InputNode.vue";
import ExtractNode from "@/components/flowNodes/ExtractNode.vue";
import WriteNode from "@/components/flowNodes/WriteNode.vue";
import OutputNode from "@/components/flowNodes/OutputNode";
import LoadingNode from "@/components/flowNodes/LoadingNode.vue";
import ToolNode from "@/components/flowNodes/ToolNode.vue";
import BaseNode from "@/components/flowNodes/BaseNode.vue";
// import CustomBackground from "@/components/utilities/CustomBackground.vue";
// import { ArrowDownToLine } from "lucide-vue-next";
import axios from "axios";
import ParentNode from "../../../../components/flowNodes/ParentNode.vue";

// lucide
// import { Hand } from "lucide-vue-next";
// import { MousePointer2 } from "lucide-vue-next";

export default {
  name: "FlowPage",
  components: {
    VueFlow,
    Background,
    // CustomBackground,
    InputNode,
    ExtractNode,
    WriteNode,
    OutputNode,
    BaseNode,
    LoadingNode,
    ToolNode,
    ParentNode,
    // ArrowDownToLine,
    //lucide
    // Hand,
    // MousePointer2,
  },
  props: {
    edges: Object,
    nodes: Object,
  },
  setup() {},
  mounted() {
    this.$refs.vueFlow.fitView();
    window.addEventListener("keydown", this.handleKeyPress);
    this.vueFlowState = useVueFlow();

    // Watch internal state
    // this.$watch(
    //   () => this.vueFlowState.nodes.value,
    //   (val) => {
    //     console.log("[vueFlow.nodes] changed:", JSON.stringify(val, null, 2));
    //   },
    //   { deep: true }
    // );

    // Watch component-level nodes
    // this.$watch(
    //   "nodes",
    //   (val) => {
    //     console.log("[this.nodes] changed:", JSON.stringify(val, null, 2));
    //   },
    //   { deep: true }
    // );
  },
  beforeUnmount() {
    window.removeEventListener("keydown", this.handleKeyPress);
  },
  data() {
    return {
      mouseMode: "default",
      // mouseMode: "hand",
      outOfBounds: false,
    };
  },
  created() {
    const {
      onInit,
      onNodeDragStop,
      onConnect,
      addEdges,
      setViewport,
      toObject,
    } = useVueFlow();

    onInit((vueFlowInstance) => {
      vueFlowInstance.fitView();
    });

    // onNodeDragStop(({ event, nodes, node }) => {
    //   console.log("Node Drag Stop", { event, nodes, node });
    // });

    onConnect((connection) => {
      addEdges(connection);
    });

    this.onInit = onInit;
    this.onNodeDragStop = onNodeDragStop;
    this.onConnect = onConnect;
    this.addEdges = addEdges;
    this.setViewport = setViewport;
    this.toObject = toObject;
  },
  methods: {
    async copyToClipboard() {
      var dummy = document.createElement("textarea");
      // to avoid breaking orgain page when copying more words
      // cant copy when adding below this code
      // dummy.style.display = 'none'
      document.body.appendChild(dummy);
      //Be careful if you use texarea. setAttribute('value', value), which works with "input" does not work with "textarea". – Eduard
      dummy.value = JSON.stringify([this.nodes, this.edges]);
      dummy.select();
      document.execCommand("copy");
      document.body.removeChild(dummy);
    },
    toggleMouseMode(mode) {
      this.mouseMode = mode;
    },
    updateNodeById(targetId, nodeType, nodeData) {
      console.log(targetId);
      let newNodes = this.nodes.map((node) => {
        console.log(node);
        if (node.id === targetId) {
          console.log("hello world");
          return {
            ...node,
            type: nodeType,
            data: {
              ...node.data,
              ...nodeData, // Only update fields you pass in
            },
          };
        }
        return node;
      });
      // console.log(this.nodes);
      // console.log(newNodes);
      // this.nodes = newNodes;
      this.$emit("updateFlowChart", newNodes);
    },
    async updateNodeTool(nodeID, nodeData) {
      this.updateNodeById(nodeID, "loading_node", nodeData);
      // console.log(nodeData);

      const options = {
        method: "POST",
        url: "https://moonarchio--moonarch-backend-tools.modal.run/recommend-tool",
        "headers": {
          "Authorization":
            "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyIjoicG9ydGFsIiwic3Vic2NyaXB0aW9uX3RpZXIiOiJhZG1pbiIsImV4cGlyeV9kYXRlIjoiMjAyNi0wNC0xMFQxNjoyODo0MS44ODc3NDYrMDA6MDAiLCJleHAiOjE3NzU4Mzg1MjF9.A5z62qNGvjQQb-0-rblMyFZ7VBbW9LDa8vqV-NHyvKI",
        },
        data: {
          // liUrls: links,
          node: JSON.stringify(nodeData),
          input_flowchart: JSON.stringify([this.nodes, this.edges]),
        },
      };
      try {
        let response = await axios.request(options);
        console.log("done");
        console.log(response.data);
        this.updateNodeById(nodeID, "tool_node", response.data);
        // return response.data.results;
      } catch (error) {
        console.log(error);
      }
    },
    handleKeyPress(event) {
      if (event.key.toLowerCase() === "h") {
        // this.toggleMouseMode("hand");
        console.log("h");
      } else if (event.key.toLowerCase() === "v") {
        // this.toggleMouseMode("default");
        console.log("v");
      } else if (event.key.toLowerCase() === "p") {
        // console.log(this.nodes);
        // console.log(getNodesInside());
        console.log(this.vueFlowState.nodes.value);
      }
    },
    // updatePos() {
    //   this.nodes = this.nodes.map((node) => {
    //     return {
    //       ...node,
    //       position: {
    //         x: Math.random() * 400,
    //         y: Math.random() * 400,
    //       },
    //     };
    //   });
    // },
    logToObject() {
      console.log(this.toObject());
    },
    resetTransform() {
      this.setViewport({ x: 0, y: 0, zoom: 1 });
    },
    updateViewport(x, y, zoom) {
      this.setViewport({ x, y, zoom });
    },
    toggleDarkMode() {
      this.dark = !this.dark;
    },
    handleMove() {
      // console.log("moving");
      const { setViewport, viewport } = useVueFlow();

      const bounds = {
        minX: 0,
        maxX: 500,
        minY: 0,
        maxY: 300,
      };

      const { x, y, zoom } = viewport.value;

      // Clamp the values
      const clampedX = this.clamp(x, bounds.minX * zoom, bounds.maxX * zoom);
      const clampedY = this.clamp(y, bounds.minY * zoom, bounds.maxY * zoom);

      // console.log(clampedX);

      if (x !== clampedX || y !== clampedY) {
        setViewport({ x: clampedX, y: clampedY, zoom });
      }
    },
    clamp(value, min, max) {
      return Math.max(min, Math.min(max, value));
    },
  },
};
</script>

<style scoped>
.topBar {
  width: 100px;
  height: 50px;
  background: white;
  padding: 10px;
  border: thin solid green;
}
.flowArea {
  height: calc(100% - 50px);
  width: 100%;
}
.vue-flow {
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
}
#menu {
  padding: 5px;
  background: white;
  position: absolute;
  /* left: 50px; */
  right: 450px;
  top: 70px;
  border-radius: 12px;
  z-index: 15;
  width: fit-content;
  border: thin solid #dadada;
}
.menu_btn {
  border-radius: 7px;
  cursor: pointer;
  /* padding: 5px; */
  display: flex;
  align-items: center;
  justify-content: center;
  height: 30px;
  width: 30px;
}
.menu_btn:hover {
  background: #dadada;
}
.selectedMouseMode {
  background: #ccadff50;
}
.selectedMouseMode:hover {
  background: #ccadff70;
}
.topBtn {
  padding: 5px;
  background: white;
  position: absolute;
  right: 50px;
  top: 10px;
  border-radius: 12px;
  z-index: 15;
  width: fit-content;
  border: thin solid #dadada;
}
</style>
